import React from 'react'
import { motion } from 'framer-motion'

// Layout Components
import Header from './Header'
import Footer from './Footer'

// Types
import type { FC, ReactNode } from 'react'

interface RootLayoutProps {
  children: ReactNode
}

const RootLayout: FC<RootLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <Header />

      {/* Main Content */}
      <motion.main
        className="flex-1 bg-neutral-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.main>

      {/* Footer */}
      <Footer />
    </div>
  )
}

export default RootLayout